import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import { MicroContentMediaLink } from 'components/MicroContent';
import type { DigizuiteAsset } from 'models/asset';
import type { Field, SitecoreBlockProps, SitecoreLink } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { getAsset } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		heading: Field<string>;
		link: Field<SitecoreLink>;
		squareImage: Field<DigizuiteAsset[]>;
	};
}

export default function MediaLink({ fields, params }: Props) {
	if (!fields) {
		return null;
	}
	const { heading, link, squareImage } = fields;
	const image = getAsset('Templated 1:1', squareImage);
	if (!heading.value || !link.value.href || !image?.src) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="MediaLink"
				description="Requires an image, heading and link"
			/>
		);
	}
	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<div className="max-w-col-6">
				<MicroContentMediaLink
					className="align-middle"
					href={link.value.href}
					imgSrc={image?.src}
					target={link.value.target}
					text={heading.value}
				/>
			</div>
		</LayoutContainer>
	);
}
MediaLink.displayName = 'MediaLink';
